import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Lưu

import appStateSlice from "./features/appStateSlice";
import authModalSlice from "./features/authModalSlice";

import globalLoadingSlice from "./features/globalLoadingSlice";
import userSlice from "./features/userSlice";

import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux"; // ✅ You forgot this import
import cartReducer from "./features/cartState";
import orderReducer from "./features/orderSlide";
import expiredModalSlice from "./features/expiredModalSlice";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  authModal: authModalSlice,
  expiredModal: expiredModalSlice,
  globalLoading: globalLoadingSlice,
  appState: appStateSlice,
  cart: cartReducer,
  order: orderReducer,
  user: userSlice,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
export const persistor = persistStore(store);
